<template>
  <div id="app">
    <Top :windowWidth="windowWidth"></Top>
    <transition name="fade" mode="out-in">
      <router-view :windowWidth="windowWidth"></router-view>
    </transition>
    <Bottom></Bottom>
  </div>
</template>

<script>
  import Top from './components/common/Header'
  import Bottom from './components/common/Bottom'
  // import getMeta from './common/js/get-meta'
  export default {
    name: 'app',
    components: {
      Top,
      Bottom
    },
    // mixins: [getMeta],
    data () {
      return {
        windowWidth: ''
      }
    },
    mounted () {
      this.$nextTick(function () {
        window.addEventListener('resize', this.getWindowWidth)
        this.getWindowWidth()
      })
    },
    methods: {
      getWindowWidth (event) {
        this.windowWidth = document.documentElement.clientWidth
      }
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.getWindowWidth)
    }
  }
</script>

<style lang="stylus">
  [v-cloak]
    display none
</style>



// WEBPACK FOOTER //
// App.vue?dccef89c